import type { UIMessage } from "ai";
import type { ApiMessage } from "@/services/conversations";

/** Restore only typed draft results; historical writes are never re-offered. */
export function restoreMessages(messages: ApiMessage[]): UIMessage[] {
  return messages.map((message) => {
    const parts: UIMessage["parts"] = [{ type: "text", text: message.content }];
    for (const value of message.tool_calls ?? []) {
      if (!value || typeof value !== "object") continue;
      const tool = value as Record<string, unknown>;
      if (typeof tool.tool_name !== "string" || !/^draft_(patient|patient_update|appointment|stock_item|register_and_schedule)$/.test(tool.tool_name)
        || typeof tool.tool_call_id !== "string" || !tool.result) continue;
      parts.push({ type: "dynamic-tool", toolName: tool.tool_name, toolCallId: tool.tool_call_id,
        state: "output-available", input: tool.args ?? {}, output: tool.result });
    }
    return { id: message.id, role: message.role, parts };
  });
}
